import React from 'react'
import Cards from 'react-credit-cards';

import './index.css'

export default function CreditCard({ creditCard }) {

  return (
    <div className='CreditCard'>
      <div className="container">
        <span className={(creditCard.main ? 'main-badge' : 'display-hidden')}>
          Cartão Principal
      </span>
        <div className={(creditCard.main ? 'border-true' : '')}>
          <div className="card-container">
            <Cards
              cvc={creditCard.cvc}
              expiry={creditCard.expiry}
              // focused={focus}
              name={creditCard.name}
              number={creditCard.number}
            >
            </Cards>
          </div>
        </div>
      </div>
    </div>
  )
}
